<template>
  <div>
    <el-time-picker
      v-model="localValue"
      :class="`required-value-${id}`"
      class="required-value_two"
      arrow-control
    >
    </el-time-picker>
    <p v-show="showError" class="mt-2 text-muted text-danger">
      {{ messageError }}
    </p>
  </div>
</template>
<script>
import mixinVModel from 'src/util/mixinVModel';
import MixinDatePicker from 'src/util/mixinDatePicker';

export default {
  name: 'TimeCapture',
  props: {
    value: {
      default: '12:00',
    },
  },
  mixins: [mixinVModel, MixinDatePicker],
};
</script>
